import { NgModule } from '@angular/core';

import { CommonTextfieldModule } from '../../../Common/controls/textfield/textfield.module';
import { CommonCheckboxModule } from '../../../Common/controls/checkbox/checkbox.module';
import { CommonAutofocusModule } from '../../../Common/directives/common_autofocus/common_autofocus.module';
import { CommonAppNameModule } from '../../../Common/app-name/common-app-name.module';
import { CommonBooleanCheckboxModule } from '../../../Common/controls/boolean_checkbox/boolean_checkbox.module';
import { CommonDialogFactoryModule } from '@CaseOne/Common/dialog-factory/dialog-factory.module';


@NgModule({
	exports: [
		CommonTextfieldModule,
		CommonCheckboxModule,
		CommonBooleanCheckboxModule,
		CommonAutofocusModule,
		CommonAppNameModule,
		CommonDialogFactoryModule,
	],
})
export class AuthenticationCommonModule {}
